import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Tokens, Usuario } from '@/shared/domain/types';

export interface AuthState {
  user: Usuario | null;
  /** Persistido (localStorage) salvo en modo cookie. Ver docs/SEGURIDAD.md. */
  refreshToken: string | null;
  /** SOLO en memoria: nunca se persiste. */
  accessToken: string | null;
  status: 'anon' | 'auth';
}

const initialState: AuthState = {
  user: null,
  refreshToken: null,
  accessToken: null,
  status: 'anon',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSession(state, a: PayloadAction<{ user: Usuario; tokens: Tokens }>) {
      state.user = a.payload.user;
      state.accessToken = a.payload.tokens.accessToken;
      state.refreshToken = a.payload.tokens.refreshToken;
      state.status = 'auth';
    },
    setTokens(state, a: PayloadAction<Tokens>) {
      state.accessToken = a.payload.accessToken;
      if (a.payload.refreshToken) state.refreshToken = a.payload.refreshToken;
    },
    setUser(state, a: PayloadAction<Usuario>) {
      state.user = a.payload;
    },
    logout() {
      return initialState;
    },
  },
});

export const { setSession, setTokens, setUser, logout } = authSlice.actions;
export const authReducer = authSlice.reducer;
